import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ModalDialogService } from '../../modal-dialog/modal-dialog.service';
import { ClinicNotificationInput, ClinicNotificationPopupComponent, ClinicNotificationResult } from './clinic-notification-popup.component';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [
    ClinicNotificationPopupComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule
  ],
  providers: [
    ModalDialogService<ClinicNotificationResult, ClinicNotificationInput>
  ],
  exports: [
    ClinicNotificationPopupComponent
  ]
})
export class ClinicNotificationPopupModule { }
